/**
 * Integration module: app state machine (start screen → XR / compass / sim session),
 * render loop and wiring of geo, sensors, pose, render, ui and map.
 */
import { App } from './app';

export { App } from './app';
export * from './hud-state';

/** Mount the app into `root` (once per page). */
export function startApp(root: HTMLElement): App {
  return new App(root);
}
